<template>
  <div :id="id" class="modal fade" role="dialog">
    <div class="modal-dialog modal-md modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ title }}</h5>
          <button type="button" class="close" @click="closed">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <button
                  type="button"
                  class="btn btn-outline-primary py-2 px-4"
                  style="border-color: transparent"
                  @click="onBefore"
                >
                  <i class="fa fa-arrow-up"></i>
                </button>
                <button
                  type="button"
                  class="btn btn-outline-primary py-2 px-4"
                  style="border-color: transparent"
                  @click="onAfter"
                >
                  <i class="fa fa-arrow-down"></i>
                </button>
              </div>
              <div class="card-body">
                <table class="table">
                  <thead>
                    <tr>
                      <th></th>
                      <th>{{ $t("columnName.name") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="item in sortItems"
                      :key="item.ColumnName"
                      @click="selectedClick(item.ColumnName)"
                    >
                      <td>
                        <input
                          class="checkbox"
                          type="checkbox"
                          :value="item.ColumnName"
                          v-model="selecteds"
                        />
                      </td>
                      <td>{{ item.ColumnName }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" @click="saved">
            {{ $t("button.ok") }}
          </button>
          <button type="button" class="btn btn-secondary" @click="closed">
            {{ $t("button.cancel") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import tablePart from "@/components/parts/tablePart";

export default {
  data() {
    return {
      sortItems: [],
      selecteds: [],
    };
  },
  props: {
    title: String,
    trigger: Boolean,
    viewName: String,
    columns: Array,
    items: Array,
  },
  components: {
    tablePart,
  },
  computed: {
    id() {
      return `${this.viewName}`;
    },
  },
  watch: {
    items(value) {
      this.sortItems = value;
      this.sortItems.forEach((item) => {
        if (item.OnlineOrderModifierName)
          item.ColumnName = item.OnlineOrderModifierName;
      });
    },
    trigger() {
      this.selecteds = [];
      $(`#${this.id}`).modal("toggle");
    },
  },
  methods: {
    selectedClick(id) {
      const index = this.selecteds.indexOf(id);
      if (index >= 0) {
        this.selecteds.splice(index, 1);
      } else {
        this.selecteds.push(id);
      }
    },
    onBefore() {
      if (this.selecteds.length == 0) {
        this.$func.message.alert("請選擇欄位 !");
        return;
      }
      let indexes = [];
      this.selecteds.forEach((name) => {
        let index = this.sortItems.findIndex((det) => det.ColumnName == name);
        if (index >= 0) indexes.push(index);
      });
      indexes = indexes.sort();
      this.sortItems.splice(0, 0, { ColumnName: "empty" });

      indexes.forEach((index) => {
        const det = this.sortItems[index + 1];
        this.sortItems.splice(index + 1, 1);
        this.sortItems.splice(index, 0, det);
      });

      const emptyIndex = this.sortItems.findIndex(
        (d) => d.ColumnName == "empty"
      );
      this.sortItems.splice(emptyIndex, 1);
    },
    onAfter() {
      if (this.selecteds.length == 0) {
        this.$func.message.alert("請選擇欄位 !");
        return;
      }
      let indexes = [];
      this.selecteds.forEach((name) => {
        let index = this.sortItems.findIndex((det) => det.ColumnName == name);
        if (index >= 0) indexes.push(index);
      });
      indexes = indexes.sort().reverse();
      this.sortItems.push({
        ColumnName: "empty",
      });

      indexes.forEach((index) => {
        const det = this.sortItems[index];
        this.sortItems.splice(index, 1);
        this.sortItems.splice(index + 1, 0, det);
      });

      const emptyIndex = this.sortItems.findIndex(
        (d) => d.ColumnName == "empty"
      );
      this.sortItems.splice(emptyIndex, 1);
    },
    saved() {
      this.$emit("saved", this.sortItems);
    },
    closed() {
      $(`#${this.id}`).modal("toggle");
    },
  },
};
</script>
